angular.module('env.data.repos.centres', [])

    .service("centresRepository", function (rest) {
        var _this = this;
        var modelType = "CentreModel";
        var modelDefinition = rest.getDefinition(modelType);

        /**
         * Get centres
         * @returns {!Promise.<Array.<RepresentationModel>>} Promise of centres collection
         */
        _this.getCentres = function () {
            return rest.map(modelDefinition).willReturn(modelType).get();
        };

        /**
         * Get centres by ids
         * @param {string[]} ids array of model ID
         * @returns {!Promise.<Array.<RepresentationModel>>} Promise of centres collection
         */
        _this.getCentresByIds = function (ids) {
            return rest.map(modelDefinition).willReturn(modelType).get({params: {id: ids}});
        };

        /**
         * Get centre by id
         * @param id id of the centre
         * @returns {!Promise.<RepresentationModel>} Promise of centre
         */
        _this.getCentre = function (id) {
            return rest.map(modelDefinition).map(id).willReturn(modelType, id).get();
        };

        return _this;
    })

    .run(function (rest, requestCoupler, requestCouplerUtils) {
        var baserUrl = om.config.build.baseUrl;
        var modelUrl = rest.getDefinition("CentreModel").getUrl();

        requestCoupler.addCoupler(requestCouplerUtils.createSimpleGetCollectionCoupler(modelUrl, baserUrl + "/" + modelUrl));
    })

;